import api from './api';

export const statsService = {
   getDashboardStats: async () => {
      const response = await api.get('/stats/dashboard');
      return response.data;
   },

   refreshDashboardStats: async () => {
      const response = await api.post('/stats/dashboard/refresh');
      return response.data;
   },

   getPollsChartData: async ({ from, to }) => {
      const response = await api.get('/stats/charts/polls', { params: { from, to } });
      return response.data;
   },

   getDateInvitesChartData: async ({ from, to }) => {
      const response = await api.get('/stats/charts/date-invites', { params: { from, to } });
      return response.data;
   },
};
